<template>
  <div class="modal fade" id="confirm-alert" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" @click.stop>
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body">
          <span v-html="message"></span>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal" @click="$emit('confirm')">OK</button>
          <button type="button" class="btn" data-dismiss="modal" @click="$emit('close')">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message', 'customHide'],
  mounted () {
    $('#confirm-alert').modal('show')
    if (this.customHide) {
      $('#confirm-alert').on('hidden.bs.modal', (e) => {
        if (!$('#delivery-info-modal').length) {
          $('body').attr({
            style: 'padding-right: 0px !important; overflow: unset !important'
          })
        } else {
          $('body').attr('style', 'overflow: hidden !important')
        }
      })
    }
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalConfirm.vue